module.exports = __webpack_public_path__ + "img/board-of-directors.cfc85482.png";